import { createApi, notification } from '@digital/ui';
import { getJwt } from '@app/helpers';
import { msgTypeNotification } from '@app/helpers/notificationHelper';
import { ETypeNotification } from '@app/enums/ETypeNotification';

let hasAddedTransform = false;

export interface Notifiable {
  invalid: boolean;
  valid: boolean;
  notifications: Notifications[]
}
export interface Notifications {
  property: string
  message: string
}

export interface TipoOptions {
  value: string;
  text: string;
}

export interface TipoGrafico {
  categories: Array<string>;
  series: Array<any>;
}

export interface TableColluns {
  title: string,
  dataIndex: string,
}

const api = createApi({
  baseURL: '/api/',
  headers: {
    Authorization: `Bearer ${getJwt()}`,
  },
  disableNotification: true,
});

export const setAuthorizationToken = (token: string | null) => {
  if (!token) return;

  if (!hasAddedTransform) {
    api.addRequestTransform((request: any) => {
      const currentToken = localStorage.getItem("idtoken");
      if (currentToken) {
        request.headers.Authorization = `Bearer ${currentToken}`;
      } else {
        request.headers.Authorization = `Bearer ${token}`;
      }
    });
    hasAddedTransform = true;
  }

  console.log("[API] Authorization atualizado:", token.substring(0, 25) + "...");
};

api.addResponseTransform((resp: any) => {
  if (resp.status === 200 && resp.config.method === 'get') {
    if (resp.data && resp.data.invalid) {
      resp.data.notifications.forEach((item: any) => {
        msgTypeNotification(item.message, resp.data.typeNotification);
      });
    }
    return;
  }

  if (resp.status === 200 && resp.config.method !== 'get') {

    let manterDados = (resp.data.manterDadosComNotificacao && Boolean(resp.data.manterDadosComNotificacao) == true)
      || (resp.data.keepData && Boolean(resp.data.keepData) == true);

    if (resp.config.disableNotification && Boolean(resp.config.disableNotification) == true) return;

    if (resp.data.invalid) {
      resp.data.notifications.forEach((item: any) => {
        msgTypeNotification(item.message, resp.data.typeNotification);
      });
    }

    if (resp.data.valid) {
      if (resp.config.method === 'put') {
        msgTypeNotification('Item atualizado com sucesso.', ETypeNotification.SUCCESS);
      } else if (resp.config.method === 'post') {
        msgTypeNotification('Item cadastrado com sucesso.', ETypeNotification.SUCCESS);
      } else if (resp.config.method === 'delete') {
        msgTypeNotification('Item removido com sucesso.', ETypeNotification.SUCCESS);
      }
    }

    if (manterDados == false) {
      resp.data = undefined;
    }

    return;
  }

  if (resp.status === 401 || resp.status === 403) {

    if (
      resp.headers['www-authenticate'] &&
      (resp.headers['www-authenticate'].includes('error_description="The token is expired"') ||
        resp.headers['www-authenticate'].includes('error="invalid_token"'))
    ) {
      resp.data = undefined;
      window.location.href = '/login';
    } else {
      msgTypeNotification('Você não possui permissão para acessar este conteúdo.');
      resp.data = undefined;
    }

    return;
  }

  if (resp.status !== 200 && resp.status !== 204) {
    msgTypeNotification('Ocorreu um erro interno.');
    resp.data = undefined;
  }

});

export default api;
